// Autoplay-on-scroll for the theme's stock "video" section (Shopify's
// <deferred-media> click-to-play pattern). Loads the deferred video as soon
// as the section scrolls into view, forces it muted + inline + controls-free
// so it behaves like a silent looping showcase clip, and pauses it again
// when scrolled out of view.
document.addEventListener('DOMContentLoaded', function () {
  var players = document.querySelectorAll('.video-section deferred-media');
  if (!players.length) return;

  players.forEach(function (media) {
    function getVideo() {
      return media.querySelector('video');
    }

    function primeVideo(video) {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay can still be blocked in rare cases; fail silently. */
        });
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            function attemptLoad() {
              if (media.hasAttribute('loaded')) {
                primeVideo(getVideo());
                return;
              }
              if (typeof media.loadContent === 'function') {
                media.loadContent(false);
                window.requestAnimationFrame(function () {
                  primeVideo(getVideo());
                });
              } else {
                var btn = media.querySelector('.deferred-media__poster');
                if (btn) btn.click();
                setTimeout(attemptLoad, 250);
              }
            }
            attemptLoad();
          } else {
            var video = getVideo();
            if (video) video.pause();
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(media);
  });
});
